import React from "react";
import { Page, PageHeader } from "components/ui/Page";
import { LargeSpacer } from "components/ui/VerticalSpacers";
import { AcademicAdvisingCard } from "components/cards/AcademicAdvisingCard";
import { AcademicProfileCard } from "components/cards/AcademicProfileCard";
import { AcademicRecordsCard } from "components/cards/AcademicRecordsCard";
import { LawDegreeAuditCard } from "components/cards/LawDegreeAuditCard";
import { SemestersCard } from "components/cards/SemestersCard";
import { StatusAndHoldsCard } from "components/cards/StatusAndHoldsCard";
import { TransferCreditCard } from "components/cards/TransferCreditCard";
import { UndergradDegreeRequirementsCard } from "components/cards/UndergradDegreeRequirementsCard";
import { PNPCalculatorCard } from "components/cards/PNPCalculatorCard";
import { GraduateDegreeProgressCard } from "components/cards/GraduateDegreeProgressCard";
import SemestersContext from "components/contexts/SemestersContext";
import { StudentFinalExamScheduleCard } from "components/cards/StudentFinalExamScheduleCard";
import { EnrollmentCards } from "components/cards/EnrollmentCards";
import { TeachingCoursesCard } from "components/cards/TeachingCoursesCard";
import { HigherDegreeCommitteesCard } from "components/cards/HigherDegreeCommitteesCard";
import { FacultyHigherDegreeCommitteesCard } from "components/cards/FacultyHigherDegreeCommitteesCard";
import {
  EvenThirdsLayout,
  PageColumn,
  ColumnAtBreakpoint,
  ColumnUnlessBreakpoint,
} from "components/ui/PageColumns";

export function StudentAcademicsPage() {
  return (
    <Page>
      <PageHeader>My Academics</PageHeader>
      <LargeSpacer />
      <EvenThirdsLayout>
        <PageColumn>
          <AcademicProfileCard />
          <StatusAndHoldsCard />
          <AcademicRecordsCard />
        </PageColumn>
        <ColumnAtBreakpoint breakpointName="medium">
          <ColumnUnlessBreakpoint breakpointName="medium">
            <SemestersCard />
            <LawDegreeAuditCard />
            <UndergradDegreeRequirementsCard />
            <PNPCalculatorCard />
            <GraduateDegreeProgressCard />
            <TeachingCoursesCard />
            <HigherDegreeCommitteesCard />
            <FacultyHigherDegreeCommitteesCard />
          </ColumnUnlessBreakpoint>
          <ColumnUnlessBreakpoint breakpointName="medium">
            <EnrollmentCards />
            <SemestersContext.Consumer>
              {({ currentStudentSemester, semesters, loadState }) => {
                return (
                  <StudentFinalExamScheduleCard
                    currentSemester={currentStudentSemester}
                    semesters={semesters}
                    loadState={loadState}
                  />
                );
              }}
            </SemestersContext.Consumer>
            <AcademicAdvisingCard />
            <TransferCreditCard />
          </ColumnUnlessBreakpoint>
        </ColumnAtBreakpoint>
      </EvenThirdsLayout>
    </Page>
  );
}
